import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const ContentHubContentWrapper = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: -220px auto 0 auto;
  padding: 0px 10px;
`;

export const ContentHubMainContentContainer = styled.div`
  display: flex;

  /* if changing media query, also update SideBar & SideBarContainer in ContentHubSideBar.style */
  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const ContentHubMainContentWrapper = styled.div`
  flex: 1;
  min-height: 225px;
`;

export const ContentHubMainContent = styled.section`
  border-radius: 8px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.white};

  ${ContentHubMainContentWrapper} {
    padding: 25px;
  }
`;
